import React from 'react';
import RestaurantUsersTable from './components/RestaurantUsersTable';

export const RestaurantUsersPage = () => {
    return <RestaurantUsersTable />;
};
